/**
 * Resolved backend base URL — same-origin when deployed, REACT_APP_BACKEND_URL only
 * for true local dev.
 *
 * History: in Feb 2026 a production deploy on Emergent ended up with the preview
 * URL baked into the JavaScript bundle, sending every API call to the wrong host.
 * Since `REACT_APP_BACKEND_URL` is inlined at build time, a misconfigured build
 * would silently break production. This helper resolves the backend URL at
 * RUNTIME based on the actual `window.location.origin`, so the same bundle works
 * across preview, production, and any custom domain without depending on the
 * baked value being correct.
 *
 * On Emergent, FastAPI is exposed at the same origin as the frontend through
 * Kubernetes ingress (`/api/*`), so same-origin is the correct default.
 */
function _resolveBackendUrl() {
  const baked = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/$/, "");
  if (typeof window === "undefined") return baked;
  const origin = window.location.origin;
  // Localhost dev: trust the baked value (so dev server can point at a non-3000 backend).
  if (/^https?:\/\/(localhost|127\.|0\.0\.0\.0)/i.test(origin)) {
    return baked || origin;
  }
  // Deployed (preview / production / custom domain): always same-origin.
  return origin;
}

export const BACKEND_URL = _resolveBackendUrl();
export const API_BASE = `${BACKEND_URL}/api`;
